// Service tags for the homepage slideshows (matches backend SERVICE_TAGS).
export const SERVICE_TAGS = [
  { slug: "maleri", title: "Måleri" },
  { slug: "renovering", title: "Renovering" },
  { slug: "tapetsering", title: "Tapetsering" },
  { slug: "fasad", title: "Fasad" },
  { slug: "mosaik-sockelputs", title: "Mosaik/Sockelputs" },
];

export const tagTitle = (slug) => SERVICE_TAGS.find((t) => t.slug === slug)?.title || slug;
